import { TableCell, Link, type TableCellProps, type LinkProps } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export interface LinkTableCellProps extends TableCellProps {
  to: string;
  linkProps?: Omit<LinkProps, 'component' | 'to'>;
}

export default function LinkTableCell({ to, linkProps, children, ...tableCellProps }: LinkTableCellProps) {
  return (
    <TableCell {...tableCellProps}>
      <Link
        component={RouterLink}
        to={to}
        underline="hover"
        color="inherit"
        sx={{ display: 'block', width: '100%' }}
        {...linkProps}
      >
        {children}
      </Link>
    </TableCell>
  );
}
